export default __webpack_public_path__ + "static/media/gtu.15edf003.png";